module.exports = __webpack_public_path__ + "img/1579209243.d458581d.jpg";